/**
 * Ryan O'Dowd
 * 2022-08-11
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors, safeAreaInsets}) => {
  return {
    selectedTagsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      paddingHorizontal: globalScale * 8,
    },
    innerContainer: {
      flex: 1,
    },
    statusButtonGroup: {
      margin: globalScale * 8,
      marginTop: globalScale * 0,
      minHeight: globalScale * 40, // @TODO: abstract
      maxHeight: globalScale * 40, // @TODO: abstract
    },
    goalsListContainer: { // @TODO: abstract with other flatlists
      gap: 4,
      paddingBottom: safeAreaInsets.bottom + 4,
    },
    translationMenuTextWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    translationMenuText: {
      color: colors.white,
      fontSize: globalScale * 18,
    },
  };
};

export default getStyles;
